// Odisei patches — tiny client-side shims kept separate from vendor theme.js
// so Santa Helena updates don't blow them away.

(function () {
  'use strict';

  // Odisei patch: in-page anchor scroll for Shopify section hash links.
  // Shopify's URL-field normalization strips the `template--<id>__` prefix from
  // values like `#shopify-section-template--X__YYY`, so hrefs like
  // `#shopify-section-YYY` end up not matching any element in the DOM (real IDs
  // are rendered as `shopify-section-template--X__YYY`). This handler:
  //   1. Catches clicks on `a[href^="#shopify-section-"]`.
  //   2. Tries an exact `getElementById` lookup (works when the prefix is present).
  //   3. Falls back to suffix match against `__<sectionKey>` so we land on the
  //      real rendered element even after Shopify's normalization.
  //   4. Scrolls manually with a sticky-header offset so the section top lands
  //      below the header instead of being clipped by it.
  document.addEventListener('click', function (event) {
    var anchor = event.target && event.target.closest
      ? event.target.closest('a[href^="#shopify-section-"]')
      : null;
    if (!anchor) return;

    var href = anchor.getAttribute('href') || '';
    var hash = href.slice(1);
    var target = document.getElementById(hash);
    if (!target) {
      var shortId = hash.replace(/^shopify-section-/, '');
      target = document.querySelector('[id$="__' + shortId + '"]');
    }
    if (!target) return;

    event.preventDefault();

    var headerHeightVar = getComputedStyle(document.documentElement)
      .getPropertyValue('--sticky-header-height');
    var headerHeight = parseInt(headerHeightVar, 10);
    if (!headerHeight || isNaN(headerHeight)) {
      var header = document.querySelector('header.header');
      headerHeight = header ? Math.round(header.getBoundingClientRect().height) : 0;
    }

    var top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: top,
      behavior: prefersReducedMotion ? 'auto' : 'smooth'
    });
  });
})();


// Odisei patch (2026-09-04): hold Klaviyo popups until the cookie banner is
// answered. Rewritten off CookieYes onto Shopify's native consent banner.
//
// Why: the store moved from CookieYes to Shopify's own banner
// (.shopify-pc__banner), so `cookieyes_consent_update` / `cookieyes_banner_load`
// stopped firing on every page and the ONLY thing that ever released this gate
// was the 10s fallback. Measured 2026-09-04 in a real (non-headless) Chrome at
// 390x844: consent accepted at t=5.3s, the hide style still in the DOM at
// t=8.8s, gone at t=10.8s. Every visitor waited a flat 10 seconds for any
// Klaviyo form. Worse, the hide only covered the inner <form>: Klaviyo's modal
// wrapper ([data-kl-scroll-locking-modal], position:fixed, z-index 90000,
// pointer-events:auto) stayed over the whole viewport with the body
// scroll-locked, so a popup that fired left an invisible full-screen tap
// blocker for those 10 seconds. document.elementFromPoint(195,422) returned the
// wrapper, not the page. PostHog flagged both on the Back to School PDPs.
//
// Now: hide the whole modal wrapper, and release on the first of
//   - a consent answer already on record (returning visitor -> instant),
//   - the visitorConsentCollected event (first visit -> the moment they choose),
//   - no Customer Privacy API within 2s (nothing to wait for),
//   - the original 10s fallback (visitor ignores the banner entirely).
//
// Signals checked against the live store: shouldShowBanner() returns true even
// after consent is granted, so it is useless here. currentVisitorConsent() is
// {marketing:"",analytics:"",...} before the answer and {marketing:"yes",...}
// after -- that is the reliable "has answered" test, and unlike
// userCanBeTracked() it also catches a decline.
(function () {
  var STYLE_ID = 'odisei-klaviyo-delay';
  var NO_API_MS = 2000;
  var HARD_FALLBACK_MS = 10000;

  var hideStyle = document.createElement('style');
  hideStyle.id = STYLE_ID;
  hideStyle.textContent =
    '.klaviyo-form, [data-kl-scroll-locking-modal] { display: none !important; }' +
    'body.klaviyo-prevent-body-scrolling { overflow: visible !important; }';
  // This file loads from <head>, so document.head is normally already there;
  // retry briefly so the gate still installs if that ever stops being true.
  function attach() {
    var root = document.head || document.documentElement;
    if (!root) return false;
    root.appendChild(hideStyle);
    return true;
  }
  if (!attach()) {
    var attaching = setInterval(function () { if (attach()) clearInterval(attaching); }, 10);
    setTimeout(function () { clearInterval(attaching); }, 3000);
  }

  var released = false;
  function release() {
    if (released) return;
    released = true;
    var el = document.getElementById(STYLE_ID);
    if (el) el.remove();
  }

  // null = the Customer Privacy API has not loaded yet, so we cannot tell.
  function consentAnswered() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.currentVisitorConsent !== 'function') return null;
      var c = cp.currentVisitorConsent() || {};
      for (var k in c) { if (c[k]) return true; }
      return false;
    } catch (e) { return null; }
  }

  document.addEventListener('visitorConsentCollected', release);

  var t0 = Date.now();
  var poll = setInterval(function () {
    if (released) { clearInterval(poll); return; }
    var answered = consentAnswered();
    if (answered === true) { clearInterval(poll); release(); return; }
    if (answered === null && Date.now() - t0 > NO_API_MS) { clearInterval(poll); release(); return; }
    if (Date.now() - t0 > HARD_FALLBACK_MS) { clearInterval(poll); release(); }
  }, 150);

  setTimeout(release, HARD_FALLBACK_MS);
})();


// Odisei patch: redirect /cart to homepage in US market (H6 - 13/05/2026)
(function () {
  var isUS = window.Shopify && window.Shopify.country === 'US';
  if (!isUS) return;
  if (/\/cart\b/.test(window.location.pathname)) {
    window.location.replace(window.Shopify.routes ? window.Shopify.routes.root : '/en-us/');
  }
})();


// Odisei patch: Notify Me modal logic (H6 - 13/05/2026)
(function () {
  var currentProduct = { handle: '', title: '', id: '' };

  function getModal() { return document.getElementById('odisei-notify-modal'); }
  function getForm() { return document.getElementById('odisei-notify-form'); }

  function openModal(productData) {
    var modal = getModal();
    if (!modal) return;
    currentProduct = productData;
    var ph = modal.querySelector('[data-notify-product-title-placeholder]');
    if (ph) ph.textContent = productData.title || 'this product';
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    var modal = getModal();
    var form = getForm();
    if (modal) modal.hidden = true;
    document.body.style.overflow = '';
    if (form) form.reset();
    var fb = modal && modal.querySelector('.odisei-notify-modal__feedback');
    if (fb) fb.hidden = true;
    var btn = form && form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = false;
  }

  document.addEventListener('click', function (e) {
    var close = e.target.closest('[data-close]');
    if (close && getModal() && !getModal().hidden) { closeModal(); return; }

    var btn = e.target.closest('.odisei-notify-cta');
    if (!btn) return;
    openModal({
      handle: btn.dataset.notifyProductHandle,
      title: btn.dataset.notifyProductTitle,
      id: btn.dataset.notifyProductId
    });
  });

  document.addEventListener('keydown', function (e) {
    var modal = getModal();
    if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
  });

  document.addEventListener('submit', function (e) {
    if (!e.target.closest('#odisei-notify-form')) return;
    e.preventDefault();
    var form = getForm();
    if (!form) return;
    var email = form.email.value.trim();
    if (!email) return;

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    // Klaviyo Client Subscriptions API
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=SnQi6f', {
      method: 'POST',
      headers: { 'revision': '2024-10-15', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'US Notify Me',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    notify_me_product_handle: currentProduct.handle,
                    notify_me_product_title: currentProduct.title,
                    notify_me_source: 'odiseimusic.com'
                  }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: 'UZ4DWx' } }
          }
        }
      })
    })
    .then(function (res) {
      var modal = getModal();
      var fb = modal && modal.querySelector('.odisei-notify-modal__feedback');
      if (res.ok || res.status === 202) {
        if (fb) { fb.textContent = "Thanks! We'll notify you when " + currentProduct.title + ' is available.'; fb.className = 'odisei-notify-modal__feedback odisei-notify-modal__feedback--success'; fb.hidden = false; }
        setTimeout(closeModal, 2500);
      } else {
        if (fb) { fb.textContent = 'Something went wrong. Please try again.'; fb.className = 'odisei-notify-modal__feedback odisei-notify-modal__feedback--error'; fb.hidden = false; }
        if (submitBtn) submitBtn.disabled = false;
      }
    })
    .catch(function (err) {
      console.error('[Odisei Notify Me] Fetch error:', err);
      var modal = getModal();
      var fb = modal && modal.querySelector('.odisei-notify-modal__feedback');
      if (fb) { fb.textContent = 'Connection error: ' + (err.message || 'unknown') + '. Please try again.'; fb.className = 'odisei-notify-modal__feedback odisei-notify-modal__feedback--error'; fb.hidden = false; }
      if (submitBtn) submitBtn.disabled = false;
    });

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'odisei_notify_me_signup',
        product_handle: currentProduct.handle
      });
    }

  });
})();


// Odisei patch: US welcome modal — multi-method IP detection (H6 - 13/05/2026)
(function () {
  // Odisei patch 2026-09-29: modal DISABLED — it interrupted US visitors on landing and hurt
  // navigation. Delete the `return;` below to bring it back.
  return;
  var STORAGE_KEY = 'odisei_us_welcome_seen';
  var SWEETWATER_URL = 'https://www.sweetwater.com/store/search?s=odiseimusic&utm_source=odiseimusic&utm_medium=referral&utm_campaign=us_welcome_modal&utm_content=primary_cta';
  var shown = false;

  if (localStorage.getItem(STORAGE_KEY) === 'true') return;

  var blockedPaths = ['/checkout', '/account', '/policies', '/pages/odisei-play'];
  for (var i = 0; i < blockedPaths.length; i++) {
    if (window.location.pathname.indexOf(blockedPaths[i]) !== -1) return;
  }

  function showModal(source) {
    if (shown) return;
    shown = true;
    console.log('[Odisei US Welcome] Triggered via: ' + source);

    var overlay = document.createElement('div');
    overlay.id = 'odisei-us-welcome-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.style.cssText = 'position:fixed;inset:0;z-index:10000;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .3s';
    overlay.innerHTML =
      '<div style="position:absolute;inset:0;background:rgba(0,0,0,.8)" data-close-welcome></div>' +
      '<div style="position:relative;background:#fff;padding:52px 40px 40px;max-width:640px;width:calc(100% - 24px);border-radius:20px;text-align:center;box-shadow:0 24px 80px rgba(0,0,0,.5)">' +
        '<button data-close-welcome aria-label="Close" style="position:absolute;top:16px;right:16px;background:none;border:none;font-size:32px;cursor:pointer;width:40px;height:40px;line-height:1;color:#333">&times;</button>' +
        '<div style="font-size:56px;margin-bottom:20px">🇺🇸</div>' +
        '<h2 style="margin:0 0 12px;font-size:34px;font-weight:700;color:#111">Hello, USA!</h2>' +
        '<p style="margin:0 auto 32px;font-size:18px;line-height:1.6;color:#444;text-align:center;max-width:380px">' +
          'Odisei Music instruments are available in the US through our official partner, <strong>Sweetwater</strong>.</p>' +
        '<a href="' + SWEETWATER_URL + '" target="_blank" rel="noopener" data-track="us_welcome_to_sweetwater" ' +
          'style="display:inline-block;background:#0218A0;color:#fff;padding:20px 48px;border-radius:999px;text-decoration:none;font-weight:600;font-size:18px;margin-bottom:16px;box-sizing:border-box;letter-spacing:.3px">' +
          'Shop on Sweetwater</a>' +
        '<br>' +
        '<button data-close-welcome data-track="us_welcome_continue_browsing" ' +
          'style="display:inline-block;background:none;border:none;color:#666;padding:14px;font-size:15px;text-decoration:underline;cursor:pointer;margin-top:4px">' +
          'Continue Browsing Our Site</button>' +
      '</div>';

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { overlay.style.opacity = '1'; });

    function close() {
      overlay.style.opacity = '0';
      setTimeout(function () { overlay.remove(); document.body.style.overflow = ''; }, 300);
      localStorage.setItem(STORAGE_KEY, 'true');
    }

    overlay.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-close-welcome')) close();
      var tracked = e.target.closest('[data-track]');
      if (tracked && window.dataLayer) {
        window.dataLayer.push({ event: 'odisei_us_welcome', action: tracked.dataset.track });
      }
      if (tracked) localStorage.setItem(STORAGE_KEY, 'true');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.getElementById('odisei-us-welcome-modal')) close();
    });
  }

  // Method 1: URL path
  if (window.location.pathname.indexOf('/en-us') === 0) {
    setTimeout(function () { showModal('url-path'); }, 300);
    return;
  }

  // Method 2: Shopify.country (set by Shopify based on market/geo)
  if (window.Shopify && window.Shopify.country === 'US') {
    setTimeout(function () { showModal('Shopify.country'); }, 300);
    return;
  }

  // Method 3: Shopify browsing context (geo-IP detection)
  console.log('[Odisei US Welcome] Checking Shopify geo detection...');
  console.log('[Odisei US Welcome] Shopify.country =', window.Shopify && window.Shopify.country);

  fetch('/browsing_context_suggestions.json')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      console.log('[Odisei US Welcome] browsing_context_suggestions:', JSON.stringify(data));
      var detected = data && data.detected_values && data.detected_values.country;
      if (detected && detected.handle === 'US') {
        showModal('browsing_context');
      }
    })
    .catch(function (err) {
      console.log('[Odisei US Welcome] browsing_context failed:', err.message);
    });

  // Method 4: Shopify localization recommendation (fallback)
  fetch('/localization.json')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      console.log('[Odisei US Welcome] localization.json:', JSON.stringify(data).substring(0, 300));
      if (data && data.country && data.country.iso_code === 'US') {
        showModal('localization.json');
      }
    })
    .catch(function (err) {
      console.log('[Odisei US Welcome] localization.json failed:', err.message);
    });
})();



// Odisei patch: strip free shipping phrases from descriptions in US market (H6 iter1v2)
(function () {
  var isUS = (window.Shopify && window.Shopify.country === 'US') ||
             (document.documentElement.lang || '').toLowerCase().indexOf('en-us') !== -1 ||
             window.location.pathname.indexOf('/en-us') === 0;
  if (!isUS) return;
  var patterns = [
    /Order now and get free shipping[!.]?\s*/gi,
    /Free shipping worldwide[!.]?\s*/gi,
    /Worldwide free shipping[!.]?\s*/gi
  ];
  function clean() {
    document.querySelectorAll('.product__description, .product-description, .rte, [data-product-description]').forEach(function (el) {
      var html = el.innerHTML;
      var orig = html;
      patterns.forEach(function (re) { html = html.replace(re, ''); });
      if (html !== orig) el.innerHTML = html;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clean);
  else clean();
})();




// Odisei patch (temporary, ends 2026-06-07): clarinet-bundle promo countdown ticker.
// Reads [data-odisei-countdown][data-expires=ISO8601] elements, updates D/H/M/S
// every second, hides the element once the deadline passes. Server-side Liquid
// in main-product.liquid already gates the markup on date + product.handle, so
// this script only needs to keep the visible counter in sync mid-session.
// Delete this IIFE when the promo ends.
(function () {
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick(el, expiresMs) {
    var diff = expiresMs - Date.now();
    if (diff <= 0) {
      el.setAttribute('hidden', '');
      return false;
    }
    var s = Math.floor(diff / 1000);
    var days = Math.floor(s / 86400); s -= days * 86400;
    var hours = Math.floor(s / 3600); s -= hours * 3600;
    var minutes = Math.floor(s / 60);
    var seconds = s - minutes * 60;
    var d = el.querySelector('[data-days]');
    var h = el.querySelector('[data-hours]');
    var m = el.querySelector('[data-minutes]');
    var sec = el.querySelector('[data-seconds]');
    if (d) d.textContent = pad(days);
    if (h) h.textContent = pad(hours);
    if (m) m.textContent = pad(minutes);
    if (sec) sec.textContent = pad(seconds);
    return true;
  }

  function init() {
    var nodes = document.querySelectorAll('[data-odisei-countdown]');
    if (!nodes.length) return;
    nodes.forEach(function (el) {
      var expires = el.getAttribute('data-expires');
      if (!expires) return;
      var expiresMs = Date.parse(expires);
      if (isNaN(expiresMs)) return;
      if (!tick(el, expiresMs)) return;
      var iv = setInterval(function () {
        if (!tick(el, expiresMs)) clearInterval(iv);
      }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


// Odisei patch (temporary, ends 2026-06-07): floating bundle CTA on
// /pages/travel-clarinet. Handles:
//   1. Add-to-Cart: posts the bundle variant to /cart/add.js (FormData), then
//      dispatches `cart:refresh` with `detail.open: true`. Santa Helena's
//      <cart-drawer> custom element handles this natively — it re-fetches its
//      section HTML via `?section_id=…`, swaps the MiniCart innerHTML, then
//      opens itself. This is the theme's own refresh pathway, so the drawer
//      always shows fresh contents instead of the empty state it was rendered
//      with at page load.
//   2. Mobile-only fade-out: 5 seconds after the user's first meaningful
//      scroll on mobile, the widget fades out and is removed from the layout.
//      Desktop keeps it visible permanently while the promo is live.
// Delete this IIFE when the promo ends along with snippets/odisei-floating-bundle-cta.liquid.
(function () {
  var MOBILE_MQ = '(max-width: 768px)';
  var FADE_DELAY_MS = 5000;
  var FADE_TRANSITION_MS = 350;
  var SCROLL_TRIGGER_PX = 10;

  function refreshAndOpenCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      window.location.href = '/cart';
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
  }

  function addToCart(button, variantId) {
    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    var form = new FormData();
    form.append('id', String(variantId));
    form.append('quantity', '1');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: form,
      credentials: 'same-origin'
    })
      .then(function (res) {
        return res.text().then(function (txt) {
          var body;
          try { body = JSON.parse(txt); } catch (_) { body = { raw: txt }; }
          if (!res.ok) {
            var msg = (body && (body.description || body.message)) || ('HTTP ' + res.status);
            throw new Error(msg);
          }
          return body;
        });
      })
      .then(function () {
        button.textContent = 'Added';
        refreshAndOpenCartDrawer();
        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 350);
      })
      .catch(function (err) {
        if (window.console && console.error) console.error('[Odisei floating ATC]', err);
        button.textContent = 'Try again';
        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 1800);
      });
  }

  function initFadeOut(widget) {
    var mq = window.matchMedia ? window.matchMedia(MOBILE_MQ) : null;
    if (!mq || !mq.matches) return; // desktop / large viewports: keep widget visible
    var armed = false;

    function onScroll() {
      if (armed) return;
      if (window.scrollY < SCROLL_TRIGGER_PX) return;
      armed = true;
      window.removeEventListener('scroll', onScroll);
      setTimeout(function () {
        widget.setAttribute('data-faded', 'true');
        setTimeout(function () {
          widget.setAttribute('hidden', '');
        }, FADE_TRANSITION_MS);
      }, FADE_DELAY_MS);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initWidget(widget) {
    widget.addEventListener('click', function (event) {
      var atcBtn = event.target.closest('[data-odisei-floating-atc]');
      if (!atcBtn) return;
      event.preventDefault();
      var variantId = widget.getAttribute('data-variant-id');
      if (!variantId || variantId === '0') {
        if (window.console && console.error) console.error('[Odisei floating ATC] missing variant id on widget');
        return;
      }
      addToCart(atcBtn, variantId);
    });

    initFadeOut(widget);
  }

  function init() {
    var widget = document.querySelector('[data-odisei-floating-cta]');
    if (widget) initWidget(widget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();




// Odisei patch: Judge.me - only show 4-5 star reviews (carousel + standard widget)
(function () {
  'use strict';
  var MIN = 4;

  // 1) Data-layer filter (primary). The reviews "Cards Carousel" fetches all its
  //    reviews once from .../reviews_for_carousel and then builds/counts/paginates
  //    from that array. Judge.me's free plan can't filter by rating server-side,
  //    so we drop < MIN-star reviews from the response before the widget sees them.
  //    This script is loaded synchronously in <head>, before the carousel's
  //    body-level fetch, so the override is always in place first.
  if (window.fetch && typeof Response === 'function' && !window.__odiseiJdgmFetchPatched) {
    window.__odiseiJdgmFetchPatched = true;
    var origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('reviews_for_carousel') === -1) return origFetch(input, init);
      return origFetch(input, init).then(function (resp) {
        return resp.clone().json().then(function (data) {
          if (data && Array.isArray(data.reviews)) {
            data.reviews = data.reviews.filter(function (r) { return Number(r && r.rating) >= MIN; });
          }
          return new Response(JSON.stringify(data), {
            status: resp.status, statusText: resp.statusText,
            headers: { 'Content-Type': 'application/json' }
          });
        }).catch(function () { return resp; });
      });
    };
  }

  // 2) DOM fallback (defense-in-depth + covers the standard review widget).
  //    Carousel cards carry no score attribute; derive rating from the star spans.
  function cardRating(card) {
    if (!card.querySelector('.jdgm-stars .jdgm-star')) return null;
    var on = card.querySelectorAll('.jdgm-stars .jdgm-star.jdgm--on').length;
    var half = card.querySelector('.jdgm-stars .jdgm-star.jdgm--half') ? 0.5 : 0;
    return on + half;
  }
  function filterReviews() {
    document.querySelectorAll('.jdgm-rev[data-score]').forEach(function (rev) {
      if (parseInt(rev.getAttribute('data-score'), 10) < MIN) rev.style.display = 'none';
    });
    document.querySelectorAll('.jdgm-card, .jdgm-media-card').forEach(function (card) {
      var r = cardRating(card);
      if (r !== null && r < MIN) card.style.display = 'none';
    });
  }
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; filterReviews(); }, 300);
  }
  function start() {
    schedule();
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); break; }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


// Odisei patch: B2B stacked-list collection view (2026-06-05).
// Powers snippets/odisei-b2b-collection-list.liquid — the dense reorder list
// shown to logged-in B2B (company) customers in place of the product grid.
// Event-delegated on document so it survives the collection's facet/sort/
// paginate AJAX reloads (which re-render #ProductGridContainer). Handles:
//   1. variant <select> change -> swap row unit price + SKU + qty rule
//   2. qty steppers (- / +) honouring B2B quantity_rule (min / increment / max)
//   3. Add -> POST /cart/add.js, then cart:refresh {open:true} (theme's own
//      drawer-refresh pathway, same as the floating bundle CTA above).
(function () {
  function closest(el, sel) {
    while (el && el.nodeType === 1) { if (el.matches(sel)) return el; el = el.parentElement; }
    return null;
  }

  function refreshAndOpenCartDrawer() {
    if (!document.querySelector('cart-drawer')) { window.location.href = '/cart'; return; }
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
  }

  // Clamp a quantity to its row's min / step / max rules.
  function clampQty(input) {
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var step = parseInt(input.getAttribute('step'), 10) || 1;
    var maxAttr = input.getAttribute('max');
    var max = maxAttr ? parseInt(maxAttr, 10) : null;
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < min) val = min;
    // snap up to the nearest valid increment above min
    if (step > 1) {
      var over = (val - min) % step;
      if (over !== 0) val = val + (step - over);
    }
    if (max !== null && val > max) {
      // step down to the largest valid value <= max
      val = max - ((max - min) % step);
    }
    input.value = val;
    return val;
  }

  function onVariantChange(select) {
    var row = closest(select, '[data-odisei-b2b-row]');
    if (!row) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;

    row.setAttribute('data-variant-id', opt.value);

    var priceEl = row.querySelector('[data-odisei-b2b-price]');
    if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;

    var skuEl = row.querySelector('[data-odisei-b2b-sku]');
    if (skuEl) skuEl.textContent = opt.dataset.sku || '';

    var qty = row.querySelector('[data-odisei-b2b-qty]');
    if (qty) {
      qty.setAttribute('min', opt.dataset.min || '1');
      qty.setAttribute('step', opt.dataset.step || '1');
      if (opt.dataset.max) { qty.setAttribute('max', opt.dataset.max); } else { qty.removeAttribute('max'); }
      qty.value = opt.dataset.min || '1';
    }

    var add = row.querySelector('[data-odisei-b2b-add]');
    if (add) {
      var available = opt.dataset.available !== 'false';
      add.disabled = !available;
      if (available) { add.removeAttribute('aria-disabled'); } else { add.setAttribute('aria-disabled', 'true'); }
      var txt = add.querySelector('.odisei-b2b-add__text');
      if (txt) txt.textContent = available ? (add.dataset.addLabel || 'Add') : (add.dataset.soldLabel || 'Sold out');
    }
  }

  function addToCart(button) {
    var row = closest(button, '[data-odisei-b2b-row]');
    if (!row) return;
    var variantId = row.getAttribute('data-variant-id');
    var qtyInput = row.querySelector('[data-odisei-b2b-qty]');
    var quantity = qtyInput ? clampQty(qtyInput) : 1;
    if (!variantId) return;

    var txt = button.querySelector('.odisei-b2b-add__text');
    var label = txt ? txt.textContent : button.textContent;
    button.disabled = true;
    button.setAttribute('data-state', 'loading');
    if (txt) txt.textContent = 'Adding...';

    var form = new FormData();
    form.append('id', String(variantId));
    form.append('quantity', String(quantity));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: form,
      credentials: 'same-origin'
    })
      .then(function (res) {
        return res.text().then(function (raw) {
          var body; try { body = JSON.parse(raw); } catch (e) { body = { raw: raw }; }
          if (!res.ok) throw new Error((body && (body.description || body.message)) || ('HTTP ' + res.status));
          return body;
        });
      })
      .then(function () {
        button.setAttribute('data-state', 'added');
        if (txt) txt.textContent = 'Added';
        refreshAndOpenCartDrawer();
        setTimeout(function () {
          button.disabled = false;
          button.removeAttribute('data-state');
          if (txt) txt.textContent = label;
        }, 1200);
      })
      .catch(function (err) {
        if (window.console && console.error) console.error('[Odisei B2B list]', err);
        button.removeAttribute('data-state');
        if (txt) txt.textContent = 'Try again';
        setTimeout(function () {
          button.disabled = false;
          if (txt) txt.textContent = label;
        }, 1800);
      });
  }

  document.addEventListener('change', function (e) {
    var select = closest(e.target, '[data-odisei-b2b-variant]');
    if (select) onVariantChange(select);
  });

  document.addEventListener('input', function (e) {
    // no-op while typing; clamping happens on blur / add
  });

  document.addEventListener('blur', function (e) {
    var qty = closest(e.target, '[data-odisei-b2b-qty]');
    if (qty) clampQty(qty);
  }, true);

  document.addEventListener('click', function (e) {
    var add = closest(e.target, '[data-odisei-b2b-add]');
    if (add && !add.disabled) { addToCart(add); return; }

    var minus = closest(e.target, '[data-odisei-b2b-minus]');
    if (minus) {
      var row1 = closest(minus, '[data-odisei-b2b-row]');
      var qi = row1 && row1.querySelector('[data-odisei-b2b-qty]');
      if (qi) {
        var step1 = parseInt(qi.getAttribute('step'), 10) || 1;
        qi.value = (parseInt(qi.value, 10) || 0) - step1;
        clampQty(qi);
      }
      return;
    }

    var plus = closest(e.target, '[data-odisei-b2b-plus]');
    if (plus) {
      var row2 = closest(plus, '[data-odisei-b2b-row]');
      var qi2 = row2 && row2.querySelector('[data-odisei-b2b-qty]');
      if (qi2) {
        var step2 = parseInt(qi2.getAttribute('step'), 10) || 1;
        qi2.value = (parseInt(qi2.value, 10) || 0) + step2;
        clampQty(qi2);
      }
      return;
    }
  });
})();
/* Odisei patch (2026-07-21): suppress Klaviyo modal popups for logged-in B2B customers. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }
  ready(function () {
    if (!document.body || !document.body.classList.contains('odisei-b2b')) return;
    console.log('[Odisei] B2B Klaviyo popup suppressor active');
    function killModals() {
      document.querySelectorAll('[data-testid="modal-form-container"]').forEach(function (modal) {
        var node = modal;
        while (node.parentElement && node.parentElement !== document.body && node.parentElement.tagName !== 'HTML') {
          node = node.parentElement;
        }
        node.remove();
      });
    }
    killModals();
    new MutationObserver(killModals).observe(document.documentElement, { childList: true, subtree: true });
  });
})();
/* Odisei patch (2026-09-16): out-of-stock messaging (6TSINEAR earphones).

   The theme already swaps the CTA to a back-in-stock button, but it never said
   WHY a 669 EUR bundle was dead, and never said the instrument itself is still
   in stock. Four bundles died because one 45 EUR component (6TSINEAR) hit zero
   -- and the Travel Clarinet currently has NO buyable bundle at all, since both
   of its bundles carry the earphones.

   This block owns four things, all locale-aware (EN/ES/FR):
     1. the PDP explainer band, with links to what IS buyable today
     2. the card badge text: "Sold Out" -> "Available Soon"
     3. the PDP CTA text:    "Sold Out - Notify me..." -> "Notify Me When It's Available"
     4. the "All together" card button, re-enabled to open the same drawer
        instead of sitting there greyed out saying "Sold Out"

   Gated on product ID (locale-proof; ES/FR handles are translated) AND on the
   theme's own .buy-buttons.back-in-stock class, so the band disappears by
   itself the moment stock returns -- no second deploy to take it down. The
   badge and CTA rewrites are keyed on classes the theme only renders while
   unavailable, so they retire themselves the same way.

   ETA copy is deliberately vague ("a few weeks") so we are not on the hook for
   a date. To change it, edit the `body*` strings below.

   Revert: delete this block. Pairs with the .odisei-oos rules in
   odisei-patches.css. */
(function () {
  /* Emptied 2026-10-30: 6TSINEAR restocked to 1000, all four bundles buyable
     again. The .back-in-stock gate below is present on every PDP, in stock or
     not, so the band never retired itself -- and reviveOpsButton() was turning
     the working "All together" Add to Cart into a notify button. To bring the
     band back for a product, re-add `<product id>: 'ts2' | 'tc' | 'self'`. */
  var PRODUCTS = {};

  /* Handles are translated per locale, so every fallback link carries all three. */
  var LINKS = {
    study:    { label: 'Study Bundle',    en: 'travel-sax-2-study-bundle',  es: 'pack-estudio-travel-sax-2', fr: 'pack-etude-travel-sax-2' },
    travel:   { label: 'Travel Bundle',   en: 'travel-sax-2-travel-bundle', es: 'pack-viaje-travel-sax-2',   fr: 'pack-voyage-travel-sax-2' },
    clarinet: { label: 'Travel Clarinet', en: 'travel-clarinet',            es: 'travel-clarinet',           fr: 'travel-clarinet' }
  };

  /* EN is title case because Mario asked for it. ES/FR stay sentence case --
     title case is an English convention and reads as broken in both. */
  var COPY = {
    en: {
      badge:    'Available Soon',
      cta:      'Notify Me When It’s Available',
      title:    'Temporarily Out of Stock',
      bodyTs2:  'Will be available in a few weeks. Check the bundles that are available today:',
      bodyTc:   'Will be available in a few weeks. Check what is available today:',
      bodySelf: 'Will be available in a few weeks. Leave your email below and we will tell you the moment they are back.'
    },
    es: {
      badge:    'Disponible pronto',
      cta:      'Avísame cuando esté disponible',
      title:    'Sin stock temporalmente',
      bodyTs2:  'Estará disponible en unas semanas. Mira los packs que sí tienes hoy:',
      bodyTc:   'Estará disponible en unas semanas. Mira lo que sí tienes hoy:',
      bodySelf: 'Estarán disponibles en unas semanas. Déjanos tu email y te avisamos en cuanto vuelvan.'
    },
    fr: {
      badge:    'Bientôt disponible',
      cta:      'Prévenez-moi dès son retour',
      title:    'Temporairement en rupture de stock',
      bodyTs2:  'Disponible dans quelques semaines. Découvrez les packs disponibles aujourd’hui :',
      bodyTc:   'Disponible dans quelques semaines. Découvrez ce qui est disponible aujourd’hui :',
      bodySelf: 'Disponibles dans quelques semaines. Laissez-nous votre e-mail et nous vous préviendrons dès leur retour.'
    }
  };

  var WARN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"'
    + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line>'
    + '<line x1="12" y1="16" x2="12.01" y2="16"></line></svg>';

  function t() {
    var l = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en';
    l = String(l).slice(0, 2).toLowerCase();
    return COPY[l] ? COPY[l] : COPY.en;
  }

  function langKey() {
    var l = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en';
    l = String(l).slice(0, 2).toLowerCase();
    return COPY[l] ? l : 'en';
  }

  function productId() {
    try { return window.ShopifyAnalytics.meta.product.id; } catch (e) { return null; }
  }

  function href(key, l) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'products/' + LINKS[key][l];
  }

  function linkHtml(keys, l) {
    return '<span class="odisei-oos__links">' + keys.map(function (k) {
      return '<a class="odisei-oos__link" href="' + href(k, l) + '">' + LINKS[k].label + ' →</a>';
    }).join('') + '</span>';
  }

  function build(kind) {
    var c = t(), l = langKey();
    var el = document.createElement('div');
    el.className = 'odisei-oos';
    el.setAttribute('data-odisei-oos', '');

    var body = kind === 'self' ? c.bodySelf : (kind === 'tc' ? c.bodyTc : c.bodyTs2);
    var html = '<p class="odisei-oos__title">' + WARN + '<span>' + c.title + '</span></p>'
      + '<p class="odisei-oos__body">' + body + '</p>';

    if (kind === 'ts2')      { html += linkHtml(['study', 'travel'], l); }
    else if (kind === 'tc')  { html += linkHtml(['clarinet'], l); }

    el.innerHTML = html;
    return el;
  }

  /* ---- 1. the PDP band ---- */
  function mountBand() {
    var kind = PRODUCTS[productId()];
    if (!kind) return;

    /* The theme adds .back-in-stock to .buy-buttons only while unavailable.
       No class, no band -- this self-retires when 6TSINEAR is restocked. */
    var alert = document.querySelector('.buy-buttons.back-in-stock');
    if (!alert) return;

    var anchor = alert.closest('.product-form__buttons') || alert;
    if (!anchor.parentNode) return;
    if (anchor.parentNode.querySelector('[data-odisei-oos]')) return;

    anchor.parentNode.insertBefore(build(kind), anchor);
  }

  /* ---- 2. card badges: "Sold Out" -> "Available Soon" ---- */
  function relabelBadges() {
    var label = t().badge;
    document.querySelectorAll('.badge--soldout').forEach(function (b) {
      if (b.textContent.trim() !== label) b.textContent = label;
    });
  }

  /* ---- 3. the PDP back-in-stock CTA ---- */
  function relabelCta() {
    var label = t().cta;
    document.querySelectorAll('.product-form__alert').forEach(function (btn) {
      var slot = btn.querySelector('.btn-text') || btn;
      if (slot.textContent.trim() !== label) slot.textContent = label;
    });
  }

  /* ---- 4. the "All together" card button ----
     snippets/odisei-pro-trial.liquid mirrors the main form's disabled state
     onto its own button, so it renders a dead grey "Sold Out". Re-point it at
     the back-in-stock drawer instead of editing that snippet (a .liquid
     read-modify-write we cannot checksum-verify). Re-applied every tick
     because that inline script re-disables it on variant change. */
  function reviveOpsButton() {
    var alert = document.querySelector('.product-form__alert');
    if (!alert) return;
    var label = t().cta;
    document.querySelectorAll('.odisei-ops__btn').forEach(function (btn) {
      if (!btn.disabled && btn.hasAttribute('data-odisei-oos-notify')
          && btn.textContent.trim() === label) return;
      btn.disabled = false;
      btn.type = 'button';
      btn.textContent = label;
      btn.setAttribute('data-odisei-oos-notify', '');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.odisei-ops__btn[data-odisei-oos-notify]');
    if (!btn) return;
    var alert = document.querySelector('.product-form__alert');
    if (!alert) return;
    e.preventDefault();
    e.stopPropagation();
    alert.click();
  }, true);

  function tick() {
    relabelBadges();
    if (PRODUCTS[productId()]) {
      mountBand();
      relabelCta();
      reviveOpsButton();
    }
  }

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    tick();
    /* Variant switches re-render the buy-buttons block and drop our node;
       carousels and quick-view inject fresh cards with fresh badges.
       Coalesced into one rAF so a chatty page does not run tick() per mutation. */
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; tick(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  });
})();

/* Odisei patch (EU tax notice, 2026-09-28): "Taxes Included" is only true for
   EU buyers; outside the EU the VAT is stripped at checkout and import taxes
   are paid on delivery. Shopify's own IP lookup says where the visitor is, and
   a non-EU country puts html.odisei-non-eu, which hides .odisei-eu-only and
   shows .odisei-non-eu-only (odisei-patches.css). The answer is kept in
   localStorage and applied here, synchronously in <head>, so later pages never
   flash the wrong copy; it is re-checked once per browser session. No answer
   means the EU copy stays. Record: ops/shopify/theme-patches/eu-tax-notice. */
(function () {
  var EU = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE',
            'IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'];
  var KEY = 'odisei_geo_country';
  var root = document.documentElement;

  function apply(cc) {
    root.classList.toggle('odisei-non-eu', EU.indexOf(cc) === -1);
  }

  try {
    var cached = localStorage.getItem(KEY);
    if (cached) apply(cached);
    if (cached && sessionStorage.getItem(KEY)) return;
  } catch (e) {}

  if (!window.fetch) return;
  fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (d) {
      var c = d && d.detected_values && d.detected_values.country;
      if (!c || !c.handle) return;
      var cc = String(c.handle).toUpperCase();
      apply(cc);
      try {
        localStorage.setItem(KEY, cc);
        sessionStorage.setItem(KEY, '1');
      } catch (e) {}
    })
    .catch(function () {});
})();

/* Odisei patch (PDP accessory add-on, 2026-10-01): the PDP tick box adds the
   Accessory Pack through the theme's own "bundles" path. This only stamps
   _attribution=pdp-addon on that line so the orders can be counted apart from
   the cart drawer cross-sell. If it fails the pack is still added, unstamped.
   Record: ops/shopify/theme-patches/cross-sell-boost. */
(function () {
  if (!window.customElements || !customElements.whenDefined) return;
  customElements.whenDefined('product-form').then(function () {
    var PF = customElements.get('product-form');
    if (!PF || PF.prototype.odiseiAddonPatched) return;
    var original = PF.prototype.prepareFormData;
    PF.prototype.prepareFormData = function (formData) {
      var out = original.call(this, formData);
      try {
        var sel = '[form="' + this.getAttribute('id') + '"] input[data-odisei-addon]:checked';
        var ids = Array.prototype.map.call(document.querySelectorAll(sel), function (i) { return String(i.value); });
        (out.items || []).forEach(function (item) {
          if (ids.indexOf(String(item.id)) !== -1) {
            item.properties = Object.assign({}, item.properties, { _attribution: 'pdp-addon' });
          }
        });
      } catch (e) {}
      return out;
    };
    PF.prototype.odiseiAddonPatched = true;
  });
})();



// Odisei patch (2026-10-22): PostHog follows Shopify's cookie banner.
//
// Why: the storefront PostHog comes from the GTM container (GTM-5K7J3TX, via the
// Stape app). Its consent wiring listens for CookieYes, which the store dropped in
// July for Shopify's own banner, so it never hears an answer. Measured 2026-10-22
// on the live site: after "Decline", the next page still sent $pageview and
// $web_vitals to eu.i.posthog.com (flagged by Kachi AI); after "Accept",
// PostHog stayed on persistence "memory", so every page load was a new person.
//
// The GTM tag already does the right thing if it is told: it reads
// localStorage.ph_consent === "granted" to choose cookie persistence. And
// posthog-js reads its opt-out from localStorage.__ph_opt_in_out_<token> when it
// starts. This file loads synchronously from <head>, before GTM, so:
//   1. no recorded "yes" -> write the opt-out before PostHog starts (nothing sent);
//   2. once Shopify's Customer Privacy API answers, follow it: analytics allowed
//      -> set ph_consent and opt in; otherwise clear it and opt out.
// Outside banner regions analyticsProcessingAllowed() is true by default, so
// those visitors are opted in about 2s in, and the suppressed $pageview is sent then.
(function () {
  var TOKEN = 'phc_bz0LRXdFKYh08VqYOsNostkQW5B2PDtiploVm4zFhzc';
  var OPT_KEY = '__ph_opt_in_out_' + TOKEN; // "0" = opted out, "1" = opted in
  var GRANT_KEY = 'ph_consent';               // read by the GTM PostHog tag
  var WAIT_MS = 10000;

  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function write(k, v) {
    try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {}
  }

  var suppressed = read(GRANT_KEY) !== 'granted';
  if (suppressed) write(OPT_KEY, '0');

  function loadedPosthog() {
    var ph = window.posthog;
    return ph && ph.__loaded && typeof ph.opt_in_capturing === 'function' ? ph : null;
  }

  // false = the Customer Privacy API has not loaded yet.
  function apply() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return false;
    var ph = loadedPosthog();
    // Ask before writing: posthog-js reads OPT_KEY live, so after the write it
    // would already answer "opted in" and the in-page switch would be skipped.
    var wasOut = ph ? ph.has_opted_out_capturing() : false;
    if (cp.analyticsProcessingAllowed()) {
      write(GRANT_KEY, 'granted');
      write(OPT_KEY, '1');
      if (wasOut) {
        ph.set_config({ persistence: 'cookie' });
        ph.opt_in_capturing({ captureEventName: false });
        if (suppressed) ph.capture('$pageview');
      }
      suppressed = false;
    } else {
      write(GRANT_KEY, null);
      write(OPT_KEY, '0');
      if (ph && !wasOut) ph.opt_out_capturing();
    }
    return true;
  }

  document.addEventListener('visitorConsentCollected', function () { setTimeout(apply, 0); });

  // Poll until both the API and PostHog are up, so the in-page opt-in/out runs
  // even when GTM loads PostHog after the API.
  var t0 = Date.now();
  var poll = setInterval(function () {
    var ready = apply();
    if ((ready && loadedPosthog()) || Date.now() - t0 > WAIT_MS) clearInterval(poll);
  }, 200);
})();


         

// Odisei patch (2026-10-22): PostHog follows Shopify's cookie banner.
//
// Why: the storefront PostHog comes from the GTM container (GTM-5K7J3TX, via the
// Stape app). Its consent wiring listens for CookieYes, which the store dropped in
// July for Shopify's own banner, so it never hears an answer. Measured 2026-10-22
// on the live site: after "Decline", the next page still sent $pageview and
// $web_vitals to eu.i.posthog.com (flagged by Kachi AI); after "Accept",
// PostHog stayed on persistence "memory", so every page load was a new person.
//
// The GTM tag already does the right thing if it is told: it reads
// localStorage.ph_consent === "granted" to choose cookie persistence. And
// posthog-js reads its opt-out from localStorage.__ph_opt_in_out_<token> when it
// starts. This file loads synchronously from <head>, before GTM, so:
//   1. no recorded "yes" -> write the opt-out before PostHog starts (nothing sent);
//   2. once Shopify's Customer Privacy API answers, follow it: analytics allowed
//      -> set ph_consent and opt in; otherwise clear it and opt out.
// Outside banner regions analyticsProcessingAllowed() is true by default, so
// those visitors are opted in about 2s in, and the suppressed $pageview is sent then.
(function () {
  var TOKEN = 'phc_bz0LRXdFKYh08VqYOsNostkQW5B2PDtiploVm4zFhzc';
  var OPT_KEY = '__ph_opt_in_out_' + TOKEN; // "0" = opted out, "1" = opted in
  var GRANT_KEY = 'ph_consent';               // read by the GTM PostHog tag
  var WAIT_MS = 10000;

  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function write(k, v) {
    try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {}
  }

  var suppressed = read(GRANT_KEY) !== 'granted';
  if (suppressed) write(OPT_KEY, '0');

  function loadedPosthog() {
    var ph = window.posthog;
    return ph && ph.__loaded && typeof ph.opt_in_capturing === 'function' ? ph : null;
  }

  // false = the Customer Privacy API has not loaded yet.
  function apply() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return false;
    var ph = loadedPosthog();
    // Ask before writing: posthog-js reads OPT_KEY live, so after the write it
    // would already answer "opted in" and the in-page switch would be skipped.
    var wasOut = ph ? ph.has_opted_out_capturing() : false;
    if (cp.analyticsProcessingAllowed()) {
      write(GRANT_KEY, 'granted');
      write(OPT_KEY, '1');
      if (wasOut) {
        ph.set_config({ persistence: 'cookie' });
        ph.opt_in_capturing({ captureEventName: false });
        if (suppressed) ph.capture('$pageview');
      }
      suppressed = false;
    } else {
      write(GRANT_KEY, null);
      write(OPT_KEY, '0');
      if (ph && !wasOut) ph.opt_out_capturing();
    }
    return true;
  }

  document.addEventListener('visitorConsentCollected', function () { setTimeout(apply, 0); });

  // Poll until both the API and PostHog are up, so the in-page opt-in/out runs
  // even when GTM loads PostHog after the API.
  var t0 = Date.now();
  var poll = setInterval(function () {
    var ready = apply();
    if ((ready && loadedPosthog()) || Date.now() - t0 > WAIT_MS) clearInterval(poll);
  }, 200);
})();       